// extracted by mini-css-extract-plugin
export default {"Container":"AuthMoveBack_Container__8yVzVYM5","Caption":"AuthMoveBack_Caption__sWQxOUWE","Button":"AuthMoveBack_Button__mTYJHKMh","Icon":"AuthMoveBack_Icon__yi0lZ4tm"};